import { useQuery } from "@tanstack/react-query"
import api from "../utils/api"

const fetchSchedule = (date) => {
    return api.get(`/v1/schedule?sportId=1&startDate=${date}&endDate=${date}`);
}

export const useScheduleData = (date) => {
    return useQuery(['schedule', date], () => fetchSchedule(date), {
        select: (data) => {
            if (!data || !data.dates) return [];
            const scheduleData = data.dates.flatMap(date => (date.games || []).map(game => game.gamePk));
            return scheduleData;
        },
        suspense: true,
        refetchInterval: 60000 // 60s Background Polling
    });
}